import { render, staticRenderFns } from "./ProductList24TshirtV3.vue?vue&type=template&id=19d6ee1a&scoped=true"
import script from "./ProductList24TshirtV3.vue?vue&type=script&lang=js"
export * from "./ProductList24TshirtV3.vue?vue&type=script&lang=js"
import style0 from "./ProductList24TshirtV3.vue?vue&type=style&index=0&id=19d6ee1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6ee1a",
  null
  
)

export default component.exports